<template>
  <div class="sort-dropdown">
    <el-select v-model="selected" placeholder="Sort By">
			<el-option :label="option.title" :value="option.value" v-for='option in options' :key='option.value'>
				{{ option.title }}
			</el-option>
    </el-select>
  </div>
</template>

<script>
export default {
	props: {
		onChange: Function,
		active: String
	},

  data() {
    return {
			selected: "",
			options: [
				{title: 'A-Z', value: 'a-z'}
				,{title: 'Z-A', value: 'z-a'}
				,{title: 'Latest', value: 'latest'}
				,{title: 'Highest Rated', value: 'rating-desc'}
				,{title: 'Lowest Rated', value: 'rating-asc'}
			]
    };
	},
	
	mounted(){
		if (this.active) {
			this.selected = this.active;
		}
	},

  watch: {
    selected(v) {
      if (this.onChange) {
				this.onChange(this.selected);
			}
    }
  }
};
</script>